import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Optional } from '@frontend/sports/common/core/utils/extended-types';
import { Store } from '@ngrx/store';
import { NumpadSource, StakeChangedEvent } from 'packages/sports/web/app/src/numpad/model';
import { Observable, map } from 'rxjs';

import { selectIsLinearBetslip } from '../../../../base/store/selectors';
import { IBetslipRootState } from '../../../../base/store/state';
import { RewardTokensActions } from '../../../reward-tokens/actions';
import { QUICK_BET_NUMPAD } from '../../../stake/models';
import { LinearFocusPlaceholderService } from '../../../stake/services/digital/linear/linear-focus-placeholder.service';
import { QuickBetActions } from '../../quick-bet-actions';
import { quickBetStateSelector, selectQuickBetStakeErrorState } from '../../quick-bet.selectors';
import { IQuickBetState } from '../../quick-bet.state';
import { QuickBetUtils } from '../../services/quick-bet-utils.service';

@Component({
    selector: 'bs-quick-bet-stake',
    templateUrl: './quick-bet-stake.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-stake.component.scss'],
    standalone: false,
})
export class QuickBetStakeComponent implements OnInit {
    quickBetState$: Observable<IQuickBetState>;
    @Input() disabled = false;
    @Input() showIncrementalStakes = true;
    @Input() inOverlay = false;
    @Input() adornmentStart?: string;

    hasBetslipErrors$: Observable<boolean>;
    numpadSource = NumpadSource.QuickBet;
    stakeFieldPlaceHolder: Optional<string>;
    protected QUICK_BET_NUMPAD = QUICK_BET_NUMPAD;

    isLinear = this.store.selectSignal(selectIsLinearBetslip);

    constructor(
        private utils: QuickBetUtils,
        private store: Store<IBetslipRootState>,
        private sitecore: Sitecore,
        private focusPlaceholderService: LinearFocusPlaceholderService,
    ) {
        this.stakeFieldPlaceHolder = this.sitecore.betslip.messages.QuickStake;
    }

    ngOnInit(): void {
        this.quickBetState$ = this.store.select(quickBetStateSelector);
        this.hasBetslipErrors$ = this.store.select(selectQuickBetStakeErrorState).pipe(
            map(({ stakeState, errors }) => {
                return errors.length > 0 && !this.utils.hideError(errors, stakeState.stake);
            }),
        );
    }

    onStakeChange(e: StakeChangedEvent): void {
        this.store.dispatch(
            QuickBetActions.changeStake({
                stake: e.stake || '0',
                silent: !this.inOverlay && !this.isLinear(),
            }),
        );
        this.store.dispatch(QuickBetActions.numpadAction({ action: e.action }));
    }

    onStakeClick(): void {
        this.store.dispatch(RewardTokensActions.hideOnboarding());
        this.store.dispatch(RewardTokensActions.hideOverlayInfo());
    }

    get focusPlaceholder(): string | undefined {
        return this.focusPlaceholderService.focusPlaceholder;
    }
}
